export const getIsDemoMode = state => state.isDemoMode;
